// import { useNavigate } from 'react-router-dom'

import './licenses.less'
import { useGetLicenses } from './get-licenses-e'
// import { Pack } from '../../components/pack'
import { Pack } from '../../../components/pack'
import Select from '../../../components/select'
import { Wrap } from '../../../components/wap'

export const MemberLicenses = (props: { ssoUrl: string }) => {
  const { ssoUrl = '' } = props
  // const navigate = useNavigate()
  const {
    product,
    macAddress,
    reason,
    onsReason,
    onMacAddress,
    productList,
    onProduct,
    onSubmit,
    userInfo,
    submitLoading,
    inputMsg
  } = useGetLicenses()

  // console.log('userInfo', userInfo)

  if (userInfo === true) {
    return (
      <div className='e-loading-element'>
        <div className='cm-spinner' />
      </div>
    )
  }

  if (userInfo === null || userInfo === false) {
    return (
      <Wrap>
        <div className='license-page'>
          <div className='no-login'>
            <h2>您还未登录</h2>
            <p>请先登录再进行操作</p>
            <button
              onClick={() => {
                window?.loginModal?.trigger()
              }}
            >
              立即登录
            </button>
          </div>
        </div>
      </Wrap>
    )
  }
  // console.log(inputMsg)
  return (
    <Wrap>
      <div className='license-page'>
        <div className='column-information'>
          <div
            className='avatar'
            style={{
              backgroundImage: `url(${userInfo?.avatar})`
            }}
          />
          <div className='right'>
            <h2 className='nickname'>{userInfo?.account}</h2>
            <button
              className='button-jump'
              onClick={() => {
                location.href = ssoUrl
              }}
            >
              个人信息
            </button>
          </div>
        </div>
        <div className='column-tabs'>
          <button className='tab-item active'>License申请</button>
          <button
            className='tab-item'
            onClick={() => {
              location.href = '/member/getlicenses'
            }}
          >
            License申请记录
          </button>
        </div>

        <div className='column-apply'>
          <ul className='box'>
            <li className='item'>
              <Select
                className={[inputMsg.product !== '' ? 'err-border' : ''].join(' ')}
                defaultValue={product}
                options={productList.map(item => {
                  return {
                    value: item.note,
                    label: item.name
                  }
                })}
                placeholder='选择产品'
                onChange={item => {
                  void onProduct(item.value)
                }}
              />
              <Pack className='err-msg' if={inputMsg.product !== ''}>
                {inputMsg.product}
              </Pack>
            </li>

            <li className='item'>
              <div
                className={['textarea', inputMsg.macAddressList !== '' ? 'err-border' : ''].join(
                  ' '
                )}
              >
                <textarea
                  id=''
                  name=''
                  placeholder='输入您的MAC地址，多条输入使用","分隔'
                  value={macAddress}
                  onChange={e => {
                    onMacAddress(e.target.value)
                  }}
                />
              </div>
              <Pack className='err-msg' if={inputMsg.macAddressList !== ''}>
                {inputMsg.macAddressList}
              </Pack>
            </li>

            <li className='item'>
              <div className='message'>
                <p>
                  Windows用户可以使用快捷键&quot;Win+R&quot;，打开运行命令，
                  输入“CMD”打开命令行窗口，输入&quot;ipconfig/all&quot;，查看以太网的物理地址(MAC地址)。
                </p>
              </div>
            </li>
            <li className='item'>
              <div className={['textarea', inputMsg.reason !== '' ? 'err-border' : ''].join(' ')}>
                <textarea
                  id=''
                  name=''
                  placeholder='申请理由'
                  value={reason}
                  onChange={e => {
                    onsReason(e.target.value)
                  }}
                />
              </div>
              <Pack className='err-msg' if={inputMsg.reason !== ''}>
                {inputMsg.reason}
              </Pack>
            </li>
            <li className='item'>
              <button
                className='button'
                disabled={submitLoading}
                onClick={() => {
                  void onSubmit()
                }}
              >
                提交申请
              </button>
            </li>
          </ul>
        </div>
      </div>
    </Wrap>
  )
}
